import {
  createAsyncThunk,
  createEntityAdapter,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';
import axios from 'axios';
import FuseUtils from '@fuse/utils';
import { addAgency, removeAgency, updateAgency } from './agencySlice';

export const getAgencies = createAsyncThunk(
  'agenciesApp/agencies/getAgencies',
  async (params, { getState }) => {
    if(getState()?.user?.role == 'provider-admin'){
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/Agency/getallPro/${getState()?.user?.id}`);
      const data = await response.data;
      return data?.staff?.data;
    }else{
    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/Agency/admin/getall`);
    const data = await response.data;
    return data?.staff?.data;
    }
  }
);

const agenciesAdapter = createEntityAdapter({
  selectId: (state) => state.agency_id
});

export const selectSearchText = ({ agenciesApp }) => agenciesApp.agencies.searchText;

export const selectFilterValue = ({ agenciesApp }) => agenciesApp.agencies.filterValue;

export const selectCustomerValue = ({ agenciesApp }) => agenciesApp.agencies.customerFilterValue;

export const operationStatus = ({ agenciesApp }) => agenciesApp.agencies.operationStatuses;

export const { selectAll: selectAgencies, selectById: selectAgenciesById } =
  agenciesAdapter.getSelectors((state) => state.agenciesApp.agencies);

  export const selectFilterValueAgencies = createSelector(
    [selectAgencies, selectFilterValue, selectCustomerValue],
    (agencies, filterVal, customerVal) => {
      let filteredAgencies = agencies;
  
      // Handle filter by 'isActive' value based on 'filterVal'
      if (filterVal === 0) {
        filteredAgencies = filteredAgencies.filter((val) => val?.isActive === 0);
      } else if (filterVal === 1) {
        filteredAgencies = filteredAgencies.filter((val) => val?.isActive === 1);
      }
  
      // Handle filter by 'customerVal' (4, 5, 6) with similar logic as filterVal
       if (customerVal === 5) {
        filteredAgencies = filteredAgencies.filter((val) => val?.customer_role === 'self-managed'); // Replace with actual condition for 5a
      } else if (customerVal === 6) {
        filteredAgencies = filteredAgencies.filter((val) => val?.customer_role === 'co-managed'); // Replace with actual condition for 6
      }else if(customerVal === 7){
        filteredAgencies = filteredAgencies.filter((val) => val?.customer_role === 'fully-managed'); 
      }
  
      // Return the final filtered agencies based on both filterVal and customerVal
      return filteredAgencies;
    }
  );
  

export const selectFilteredAgencies = createSelector(
  [selectFilterValueAgencies, selectSearchText],
  (agencies, searchText) => {
    if (searchText.length === 0) {
      return agencies;
    }
    return FuseUtils.filterArrayByAgency(agencies, searchText);
  }
);

export const selectGroupedFilteredAgencies = createSelector(
  [selectFilteredAgencies],
  (agencies) => {
    return agencies
      .sort((a, b) => a.users.username.localeCompare(b.users.username, 'es', { sensitivity: 'base' }))
      .reduce((r, e) => {
        const group = e.users.username[0];
        if (!r[group]) r[group] = { group, children: [e] };
        else r[group].children.push(e);

        return r;
      }, {});
  }
);

const agenciesSlice = createSlice({
  name: 'agenciesApp/agencies',
  initialState: agenciesAdapter.getInitialState({
    searchText: '',
    operationStatuses: "",
    filterValue: 2,
    customerFilterValue: 4
  }),
  reducers: {
    setAgenciesSearchText: {
      reducer: (state, action) => {
        state.searchText = action.payload;
      },
      prepare: (event) => ({ payload: event.target.value || '' }),
    },
    setAgenciesFilterValue:(state, action) => {
      state.filterValue = action.payload
    },
    setCustomerFilterValue:(state, action) => {
      state.customerFilterValue = action.payload
    },
    setOperationStatus: (state, action) => {
      state.operationStatuses = action.payload
    }
  },
  extraReducers: {
    [updateAgency.fulfilled]: agenciesAdapter.upsertOne,
    [addAgency.fulfilled]: (state, action) => agenciesAdapter.addOne(state, action.payload?.staff?.data),
    [removeAgency.fulfilled]: (state, action) => agenciesAdapter.removeOne(state, action.payload),
    [getAgencies.fulfilled]: (state, action) => {
      const data = action.payload;
      agenciesAdapter.setAll(state, data);
      state.searchText = '';
    },
  },
});

export const { setAgenciesSearchText, setOperationStatus, setAgenciesFilterValue, setCustomerFilterValue } = agenciesSlice.actions;

export default agenciesSlice.reducer;
